import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36 20c0 8.837-7.163 16-16 16S4 28.837 4 20 11.163 4 20 4s16 7.163 16 16Zm-17.85 8.472L30.02 16.6a1.032 1.032 0 0 0 0-1.46l-1.46-1.46a1.032 1.032 0 0 0-1.46 0l-9.68 9.682-4.52-4.52a1.032 1.032 0 0 0-1.46 0l-1.46 1.46a1.032 1.032 0 0 0 0 1.46l6.71 6.709a1.032 1.032 0 0 0 1.46 0Z" })
});
export default SvgCheckmarkFill;
